import React, { Dispatch, SetStateAction } from "react";
import Navigator from '../components/Navigation';
import { ArticleTextSection } from "../articleDetailPage/ArticleTextSection"
import { ProtectedArticleGroup } from "../articleDetailPage/ProtectedArticleGroup";
import { ArticleTitle } from "../articleDetailPage/ArticleTitle";
import { hashPassword, hashPasswordsFromEnv } from "../utils/passwordUtils";
import ArticleImageLayout from "../articleDetailPage/ArticleImageLayout";
import '../style.css';
import { Wavedivider } from "../components/Wavedivider";
import { CalloutLink } from "../components/CalloutLink";
import { useMetaTags } from '../utils/useMetaTags';
import ProtectedPage from "../components/ProtectedPage";
import { QuoteBlock } from "../components/QuoteBlock";
import ProtectedSection from "../components/ProtectedSection";
import NextItem from "../components/NextItem";
import BackButton from "../components/BackButton";
import essay2609Thumbnail from "../image/articles/essay260901.webp";
import image1 from "../image/articles/essay260902.webp";

function Essay260901(props: {
    activeNav: number, 
    setActiveNav: Dispatch<SetStateAction<number>>,
  }) {
    // const images1 = [image2, image3,  image4, image5, ];
    // const images2 = [image6, image7, image15];
    // const images3 = [image8, image9, image10];
    // const images4 = [image11, image12, image13, image14, ];
    
      
      const hashedPasswords = hashPasswordsFromEnv(
        process.env.REACT_APP_ESSAY2606_PASSWORDS
      );
      const sectionLockHashes = hashPasswordsFromEnv(
        process.env.REACT_APP_ESSAY2606_SECTION_PASSWORDS
      );
      useMetaTags({
        title: '삶을 재미있게 살아가는 원칙 - Lynkim',
        image: '/ogimage.png',
      });
      
      return (
        <>
        {/* <ProtectedPage password={hashedPasswords} description="이 페이지의 비밀번호는 개인번호로 설정되어 있어요"> */}
        <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
        <div className='fadeIn '>
            <ArticleTitle
                title={'삶을 재미있게 살아가는 원칙'}
                category={'essay'}
                date={'2026.10.09.'}
                thumbnail={image1}

            />
        </div>
        <Wavedivider/>
        <div className='articleLayout'>
           <ArticleTextSection
                title = '인생을 재미있게 산다는 것'
                titleEn = 'How to live keeping happy'
                marginBottom={true}
                description={<div>
“인생을 재밌게 산다”는 것을 즐거운 일이 많이 일어나는 삶이라고 보지는 않습니다. 오히려 시간이 지나고 돌아봤을 때, <b>“나는 꽤 많이 살아봤다”</b>는 느낌이 드는 삶에 가깝다고 생각합니다.
<br/><br/>
재미있는 삶에는 몇 가지 공통된 요소가 있는 것 같습니다.
<br/>
<QuoteBlock>
몰입: 시간 가는 줄 모르고 무언가에 빠져드는 순간<br/>
발견: 몰랐던 것을 이해하거나, 생각이 바뀌거나, 새로운 사람과 세계를 만나는 것<br/>
서사: 예상대로만 흘러가지 않고 실패하고 부딪히고 우연한 일이 생기는 것<br/>
관계: 누군가와 깊이 이야기하고, 함께 경험하고, 서로 영향을 주는 것<br/>
주도성: 남들이 좋다고 하는 삶이 아니라 내가 궁금한 것을 따라가 보는 것<br/>
기여: 내가 가진 것을 나누면서 다른 사람의 삶에도 흔적을 남기는 것
</QuoteBlock>
그래서 “재밌다”와 “즐겁다”는 조금 다릅니다. 여행하다 길을 잃는 것은 당시엔 즐겁지 않을 수 있지만 나중에는 재미있는 이야기가 됩니다. 어려운 프로젝트 때문에 몇 주 동안 씨름하는 것도 편하지 않지만, 결국 문제를 풀었을 때는 강렬한 경험이 됩니다. 누군가를 사랑하는 것도 행복뿐 아니라 불안과 상실을 포함하지만, 그만큼 삶을 깊게 만들기도 합니다.
<br/>
반대로 아주 편안하고 안정적이고 실패도 거의 없는 삶이 반드시 재미있는 삶은 아닙니다. 재미에는 어느 정도의 불확실성이 필요하기 때문입니다. 내가 이미 결과를 알고 있는 게임은 금방 지루해지는 것과 비슷합니다.
<br/><br/>
그런 의미에서 저는 재미있는 인생을 이렇게 표현하고 싶습니다.
<br/>
<b>내가 중요하다고 생각하는 것들을 좇으면서, 결과를 완전히 알 수 없는 일에 계속 참여하는 삶.</b>
<br/>
여기서 중요한 것은 자극을 많이 소비하는 것과 재미있는 삶을 사는 것을 구별하는 것입니다. 여행을 많이 하고, 술자리를 많이 가고, 새로운 사람을 계속 만난다고 해서 반드시 인생이 재미있어지는 것은 아닙니다. 그것들은 순간적인 novelty를 줄 수 있지만, 결국 소비자로만 남으면 공허해질 수 있습니다.
<br/><br/>

오히려 재미는 소비보다는 참여에서 많이 생깁니다.
<br/>
영화를 보는 것보다 영화를 만들어 보는 것, 남의 사업 이야기를 듣는 것보다 작은 제품이라도 만들어 시장에 내놓아 보는 것, 좋은 대화를 구경하는 것보다 내가 먼저 누군가에게 깊은 질문을 던지는 것, 여행지를 방문하는 것보다 그곳 사람과 관계를 만들어 보는 것처럼요.
<br/>
그리고 지금까지 당신이 이야기했던 것들을 보면, 당신에게 재미를 주는 요소는 꽤 선명해 보입니다. 어려운 문제를 이해하고 해결할 때의 몰입, 이전에는 몰랐던 세계를 배울 때의 느낌, 사람들과 깊은 대화를 나누는 것, 여행이나 호스팅처럼 낯선 사람과 경험을 공유하는 것, 그리고 무언가를 만들어 사람들에게 주는 경험이 반복해서 등장합니다.
<br/><br/>
그래서 당신에게는 단순히 “더 많이 놀아야 하나?”보다 이런 질문이 더 중요할지도 모릅니다.
<br/><br/>
<b>“최근 1년 동안 나는 관객으로 살았나, 참가자로 살았나?”</b>
<br/><br/>
회사에서 문제를 풀고, 유튜브를 보고, 책을 읽고, 투자하고, 여행하는 것 모두 재미있을 수 있습니다. 그런데 시간이 지나면서 삶이 밋밋하게 느껴진다면 새로운 자극이 부족해서가 아니라, 내가 직접 만들어가는 이야기가 부족해서일 수도 있습니다.
<br/>
그래서 저는 재미있는 인생을 설계할 때 아주 단순한 기준을 하나 써볼 만하다고 생각합니다.
<br/><br/>
<b>1년에 몇 개 정도는 “이걸 하면 무슨 일이 생길지 나도 잘 모르겠다” 싶은 일을 해보는 것.</b>
<br/><br/>
작은 서비스를 만들어 공개하거나, 새로운 공동체를 만들거나, 한 달 동안 어떤 주제를 깊게 공부해 결과물을 남기거나, 혼자 여행을 떠나거나, 평소라면 가까워지지 않았을 사람에게 먼저 다가가거나, 누군가에게 중요한 무언가를 가르쳐주는 것일 수도 있습니다.

그런 일들이 쌓이다 보면 인생은 반드시 항상 행복하지는 않더라도, 꽤 흥미로운 이야기가 됩니다.
<br/>
그리고 개인적으로 저는 마지막에 이것이 꽤 좋은 기준이라고 생각합니다.
<br/><br/>
<b>“오늘 재미있었는가?”보다 “요즘 나는 다음 장이 궁금한 삶을 살고 있는가?”</b>
<br/><br/>
그렇다면 꽤 잘 살고 있는 겁니다.
                     </div>}
                   />

               
   <ArticleTextSection
                title = '내가 삶을 재미있게 만들 수 있는 원칙'
              
                marginBottom={true}
                description={<div>
                  첫째. 나는 무언가를 만들기 위해서만 만드는 것이 아니라, 그것으로 사람들에게 즐거운 경험을 주고 싶다.<br/>
                둘째. 완성은 내가 할 수 있는 일을 확인하는 순간이고, 사람들이 즐기는 모습은 그 일이 세상과 연결되는 순간이다.<br/>
                셋째. 사람들의 즐거움을 중요하게 여기되, 모든 사람의 반응으로 내 창작의 가치와 나 자신의 가치를 결정하지 않는다.<br/>
               
                </div>}/>
                <ArticleTextSection
                
               subTitle='만들고 싶은 것보다, 누군가가 즐길 수 있는 경험에서 출발하라'
                marginBottom={true}
                description={<div>
             
                <QuoteBlock>
                                  내가 무엇을 만들고 싶은가?<br/>
                이것을 경험하는 사람은 무엇을 느끼게 될까?<br/>
                그 사람이 실제로 즐길 수 있도록 무엇을 바꿀 수 있을까?
                </QuoteBlock>
                여기서 핵심은 사람들의 취향에 무조건 맞추라는 뜻이 아닙니다.
                자신이 만들고 싶은 것과 사람들이 즐길 수 있는 것 사이의 접점을 찾는 것입니다. 자신만의 표현과 관점을 유지하면서도, 그것이 다른 사람에게 잘 전달되도록 고민하는 것이죠.
                당신에게는 창작자의 관점과 관객의 관점을 동시에 갖는 것이 중요한 능력이 될 수 있습니다.

                </div>}/>
               <ArticleTextSection
                
               subTitle='결과물을 만드는 데서 끝내지 말고, 사람들이 경험하는 장면까지 설계하라'
                marginBottom={true}
                description={<div>
                일반적인 창작자는 작품을 완성하면 자신의 역할이 끝났다고 생각할 수 있습니다.
하지만 당신에게는 공개 이후의 경험도 창작의 일부일 가능성이 높습니다.
영상이라면 사람들이 쉽게 볼 수 있도록 공유하는 것, 공연이라면 관객이 더 몰입할 수 있도록 구성하는 것, 행사를 기획한다면 참여자가 편안하고 즐겁게 머물 수 있도록 만드는 것까지 포함됩니다.
따라서 당신에게 맞는 완성의 기준은 단순히 파일을 저장하거나 무대에서 내려오는 것이 아닐 수 있습니다.

                <QuoteBlock>
                  내가 의도한 경험이 실제 사람들에게 전달되었는가?
                  </QuoteBlock>
                  
이 질문을 프로젝트의 마지막 단계에 포함해 보세요.
다만 사람들이 즐기는 모습을 직접 확인하기 어려운 온라인 콘텐츠나 비동기적인 작업에서는 댓글, 이용자의 행동, 피드백 등 다른 증거를 활용할 수 있습니다. 반드시 현장에서 모든 사람의 반응을 볼 필요는 없습니다.

                 </div>}/>
                 <ArticleTextSection
                
               subTitle='사람들의 즐거움을 관찰하고, 그 반응을 다음 창작의 재료로 삼아라'
                marginBottom={true}
                description={<div>
                당신이 사람들의 즐거움을 중요하게 생각한다면, 사람들의 반응은 단순한 평가가 아니라 학습의 자료가 됩니다.
예를 들어 영상을 공개한 뒤 다음과 같은 질문을 해볼 수 있습니다.

                <QuoteBlock>
                  사람들이 가장 좋아했던 부분은 어디였는가?<br/>
어떤 장면에서 웃거나 집중했는가?<br/>
내가 의도한 재미가 실제로 전달되었는가?<br/>
예상하지 못했지만 사람들이 좋아했던 것은 무엇인가?
                  </QuoteBlock>
                  
이렇게 하면 창작은 일회성 성취에서 끝나지 않고, 사람들의 경험을 이해하면서 점점 더 나은 결과물을 만드는 과정으로 발전합니다.
이것은 앞서 이야기한 몰입과 발견에도 연결됩니다. 사람들의 반응을 관찰하면 새로운 아이디어가 생기고, 다음 프로젝트에서 다시 시도할 수 있기 때문입니다.
다만 칭찬의 양만 측정하지는 마세요. 사람들은 예의상 칭찬할 수도 있고, 반응이 조용하더라도 실제로 깊은 만족을 느낄 수도 있습니다. 가능하면 구체적인 행동과 솔직한 피드백을 함께 살펴보는 것이 좋습니다.
                 </div>}/>
                   <ArticleTextSection
                
               subTitle='혼자서 잘 만드는 능력과 사람들을 즐겁게 하는 능력을 함께 키워라'
                marginBottom={true}
                description={<div>
                당신은 혼자 만든 결과물과 함께 만든 결과물에서 느끼는 성취감이 비슷하다고 했습니다.
따라서 반드시 팀을 꾸려야만 만족하는 사람이라고 볼 근거는 없습니다. 혼자서 깊이 몰입해 완성하는 시간도 중요할 수 있습니다.
다만 최종적인 만족이 사람들의 경험과 연결된다면, 창작 기술만큼 다음 능력도 중요해집니다.

                <QuoteBlock>
                 사람들이 무엇을 즐기는지 관찰하는 능력<br/>
자신의 생각을 다른 사람이 이해하기 쉽게 전달하는 능력<br/>
관객이나 사용자의 반응을 읽는 능력<br/>
피드백을 받아 결과물을 개선하는 능력<br/>
사람들에게 실제로 도달하도록 공개하고 배포하는 능력
          
                  </QuoteBlock>
                  
즉, 좋은 결과물을 만드는 능력과 그 결과물이 사람들에게 즐거움을 주도록 만드는 능력을 함께 발전시키는 것입니다.
이 원칙은 당신이 앞으로 어떤 분야에서 창작하든 유용하게 적용할 수 있습니다. </div>}/>
                
                
                  <ArticleTextSection
                
               subTitle='다른 사람을 즐겁게 하되, 모든 사람을 만족시키려 하지는 마라'
                marginBottom={true}
                description={<div>
                사람들이 즐기는 모습을 보는 것이 당신에게 큰 기쁨이라면, 어느 순간부터 사람들의 반응이 좋지 않을 때 자신의 창작 전체를 실패라고 느낄 수 있습니다.
그러나 다음 세 가지는 구분해야 합니다.

                <QuoteBlock>
                  1. 내가 의도한 경험을 충분히 구현했는가?<br/>
2. 실제로 사람들이 즐거움을 느꼈는가?<br/>
3. 모든 사람이 그 결과물을 좋아했는가?
          
                  </QuoteBlock>
                  
첫 번째와 두 번째는 창작의 품질을 이해하는 데 중요합니다. 세 번째는 반드시 달성해야 할 목표가 아닙니다.
어떤 작품도 모든 사람에게 똑같이 즐거움을 줄 수는 없습니다. 관객의 취향, 상황, 기대가 다르기 때문입니다.
따라서 당신에게 적합한 원칙은 사람들의 즐거움을 진지하게 추구하되, 모든 사람의 호응을 자신의 가치에 대한 판정으로 받아들이지 않는 것입니다.
사람들을 즐겁게 하는 것이 당신의 창작 동기일 수는 있지만, 그것이 자신을 끊임없이 증명해야 한다는 의무가 되어서는 안 됩니다.
                 </div>}/>

                
        <NextItem to='/Essay2609' thumbnail={essay2609Thumbnail} nextProjectTitle='26.09. 회고'/>

        <BackButton/>
        </div>
        {/* </ProtectedPage> */}
        </>
      )
  }

export default Essay260901;